import { Asset } from '@/shared/api/protocol-ts/model/dto_asset_pb';
import { getImageSrc } from '@/shared/lib';

export const getOrthoReportPreviewFromAssets = (
  reportID: string,
  assets: Asset[],
): string => {
  const panoramaAsset = assets.find(
    (asset) =>
      asset.Kind.case === 'GeneratedReport' &&
      asset.Kind.value.Belonging?.ReportID === reportID &&
      asset.Kind.value.Content.case === 'CBCTGPPanoramaReformatGeneral',
  );

  if (
    panoramaAsset?.Kind.case === 'GeneratedReport' &&
    panoramaAsset.Kind.value.Content.case === 'CBCTGPPanoramaReformatGeneral'
  ) {
    const panoramaContent = panoramaAsset.Kind.value.Content.value;
    return getImageSrc(panoramaContent.PanoramaSingle?.ID, 'preview');
  }

  return '';
};
